import React, { Component } from "react";
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";

import ApplicationStore from "../../../stores/ApplicationStore";
import HTTPIntegrationForm from "./HTTPIntegrationForm";


class UpdateHTTPIntegration extends Component {
  constructor() {
    super();

    this.state = {};
  }

  onSubmit = (integration) => {
    let integr = integration;
    integr.applicationID = this.props.application.id;

    ApplicationStore.updateHTTPIntegration(integr, resp => {
      this.props.history.push(`/organizations/${this.props.application.organizationID}/applications/${this.props.application.id}/integrations`);
    });
  } 

  componentDidMount() {
    ApplicationStore.getHTTPIntegration(this.props.application.id, (resp) => {
      this.setState({
        object: resp.integration,
      });
    });
  }

  render() {
    if (this.state.object === undefined) {
      return null;
    }

    return(
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Card>
            <CardHeader title="Update HTTP integration" />
            <CardContent>
              <HTTPIntegrationForm submitLabel="Update integration" onSubmit={this.onSubmit} object={this.state.object} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
}

export default UpdateHTTPIntegration;
